import Api from '@/services/Api'

export default {
  index () {
    return Api().get('loginUser')
  },
  show (params) {
    return Api().post('loginUserEdit', params)
  },
  showself () {
    return Api().get('loginUserProfile')
  },
  chgownpwd (params) {
    return Api().post('chgOwnPwd', params)
  },
  resetpwd (params) {
    return Api().post('reSetPwd', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/LoginUserService.js